import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import storage from '../../helpers/storage';
import { isTokenAboutToExpire } from '../../helpers/utils';
import { useCustomStore } from '../../redux/store';
import { redirectionRoutes } from '../../routes/redirectionRoutes';

export default function PageNotFound() {
    const navigate = useNavigate();
    const { user, setManualRefreshToken } = useCustomStore();

    useEffect(() => {
        /**
         * check if token is about to expire
         * call manual Refresh token.
         */
        const tokenExpireInTwoMinutes: boolean = isTokenAboutToExpire();
        if (tokenExpireInTwoMinutes) {
            setManualRefreshToken(true);
        }

        if (storage.getToken() == null) {
            return navigate(redirectionRoutes.login.path)
        } else {
            // Customer
            if(!user?.accessRight) {
                return navigate(redirectionRoutes.dashboard.path)
            }
            
            // User
            if(user?.accessRight?.hasAdminAccess || user?.accessRight?.assignRights?.dashboard.read) {
                return navigate(redirectionRoutes.dashboard.path)
            }else {
                return navigate(redirectionRoutes.profile.path)
            }
        }
    }, [navigate]);

    return (<></>);
}
